import {
  Component,
  OnInit,
  Inject,
  OnDestroy,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ValidatorFn,
  AbstractControl,
  FormControl,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import * as moment from 'moment';

import { OrgMap, ADMIN_CONSTANT, GLOBAL_CONSTANTS } from 'src/app/app.model';
import { AppService } from 'src/app/app.service';
import { takeUntil, takeWhile } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { interval, timer } from 'rxjs';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';



@Component({
  selector: 'app-bridge-dialog',
  templateUrl: './bridge-dialog.component.html',
  styleUrls: ['./bridge-dialog.component.scss'],
})
export class BridgeDialogComponent implements OnInit, OnDestroy {
  maxDOB: Date;
  title: string;
  email: string;
  orgList: OrgMap;
  isInitial: boolean;
  resetPassword: boolean;
  forgotPassword: boolean;
  passwordForm: FormGroup;
  selectedOrganization: OrgMap;

  destroy: Subject<any> = new Subject<any>();

  forgotPasswordForm: FormGroup;
  resendOTP = false;
  resendOTPTimer: number = 0;
  formSubmitted: boolean = false;
  showOTPBox = false;



  @ViewChild('OTP', { static: false }) OTP: any;

  constructor(
    public dialogRef: MatDialogRef<BridgeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private changeDetector: ChangeDetectorRef,
    private service: AppService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.onInit();
    this.initForm();
  }

  ngOnDestroy() {
    this.destroy.next(null);
    this.destroy.complete();
  }

  onInit(): void {
    this.email = this.data.email;
    this.orgList = this.data.orgMap;
    this.resetPassword = this.data.resetPassword;
    this.forgotPassword = this.data.forgotPassword;

    this.title =
      this.resetPassword || this.forgotPassword
        ? `Forget Password`
        : `Select Organization`;

    let items: OrgMap[] = [];
    if (!!this.service.getToken(ADMIN_CONSTANT.ADMIN_TOKEN_ORG_CODE)) {
      items = this.data.orgMap.filter(
        (x: OrgMap) =>
          x.OrgCode ===
          this.service.getToken(ADMIN_CONSTANT.ADMIN_TOKEN_ORG_CODE)
      );
    } else {
      items = this.data.orgMap;
    }

    this.selectedOrganization = !!items && !!items.length ? items[0] : null;
  }

  initForm(): void {
    if (this.resetPassword || this.forgotPassword) {
      this.isInitial = true;
      // this.maxDOB = moment().subtract({ years: 18, day: 1 }).toDate();
      this.maxDOB = moment().toDate();
      this.passwordForm = this.fb.group(
        {
          InputOTP: this.fb.control(null),
          Email: this.fb.control(this.email, [Validators.required, Validators.email]),
          AdminPassword: this.fb.control(null, [Validators.required, Validators.minLength(8)]),
          ReAdminPassword: this.fb.control(null, [Validators.required, Validators.minLength(8)]),
          DOB: this.fb.control({ value: this.maxDOB, disabled: true }, [
            Validators.required,
          ]),
        },
        { validator: this.passwordValidator('AdminPassword', 'ReAdminPassword') } );
      if (!!this.passwordForm.get('Email').value) {
        this.passwordForm.get('Email').disable({ emitEvent: false });
      }
    }
  }

  get InputOTP() {
    return this.passwordForm.get('InputOTP');
  }


  passwordValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName] as FormControl;
      const matchingControl = formGroup.controls[matchingControlName] as FormControl;

      if (matchingControl?.errors && !matchingControl?.errors['confirmedValidator']) {
        return;
      }

      if (control?.value !== matchingControl?.value) {
        matchingControl?.setErrors({ confirmedValidator: true });
      } else {
        matchingControl?.setErrors(null);
      }
    };
  }
  

  getSubmitText(): string {
    return this.isInitial ? 'SAVE' : 'VALIDATE';
  }

  onSelectOrg(org: OrgMap): void {
    this.selectedOrganization = org;
  }

  checkSelection(org: OrgMap): boolean {
    return (
      this.selectedOrganization &&
      this.selectedOrganization.OrgCode === org.OrgCode
    );
  }

  onNext(): void {
    if (!!this.selectedOrganization) {
      this.dialogRef.close(this.selectedOrganization);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  // onChangePassword(): void {
  //   if (this.passwordForm.valid) {
  //     const PAYLOAD = this.passwordForm.getRawValue();
  //     PAYLOAD.DOB = !!PAYLOAD.DOB
  //       ? moment(PAYLOAD.DOB).format('M/DD/YYYY')
  //       : null;
  //     (this.isInitial
  //       ? this.service.onGlobalResetPassword(PAYLOAD)
  //       : this.service.onGlobalResetPasswordValidate(PAYLOAD)
  //     )
  //       .pipe(takeUntil(this.destroy))
  //       .subscribe(
  //         (response) => {
  //           if (response.Header.Status === ADMIN_CONSTANT.SUCCESS_STATUS) {
  //             if (this.isInitial) {
  //               this.changeDetector.detectChanges();
  //               this.isInitial = false;
  //               this.passwordForm
  //                 .get('InputOTP')
  //                 .setValidators([
  //                   Validators.required,
  //                   Validators.minLength(6),
  //                   Validators.maxLength(6),
  //                 ]);
  //               this.passwordForm.get('InputOTP').updateValueAndValidity();
  //               this.service.showToast('OTP send to your device');

  //               this.changeDetector.detectChanges();
  //               this.OTP.nativeElement.focus();
  //             } else {
  //               this.resetPassword = false;
  //               this.forgotPassword = false;
  //               // this.service.showToast('OTP validated successfully');
  //               this.service.showToast('Password changed successfully');
  //               this.dialogRef.close();
  //             }
  //           } else if (response.Header.Status === ADMIN_CONSTANT.ERROR_STATUS) {
  //             this.service.showToast(response.Error.ErrorMessage);
  //           }
  //         },
  //         (err) => this.service.showToast(ADMIN_CONSTANT.SERVER_ERROR_MESSAGE)
  //       );
  //   } else {
  //     this.service.showToast(ADMIN_CONSTANT.FORM_INVALID);
  //   }
  // }



  
  onChangePassword(): void {

    if (this.isInitial) {
      this.setInputOTPValidation(false);
      this.formSubmitted = true;
    }
    const PAYLOADs = this.passwordForm.getRawValue();

    if (this.passwordForm.valid) {
      const PAYLOAD = this.passwordForm.getRawValue();
      PAYLOAD.DOB = !!PAYLOAD.DOB
        ? moment(PAYLOAD.DOB).format(GLOBAL_CONSTANTS.DOB_FORMAT)
        : null;
      (this.isInitial
        ? this.service.onGlobalResetPassword(PAYLOAD)
        : this.service.onGlobalResetPasswordValidate(PAYLOAD)
      )
        .pipe(takeUntil(this.destroy))
        .subscribe(
          (response: any) => {
            if (response.Header.Status === ADMIN_CONSTANT.SUCCESS_STATUS) {
              if (this.isInitial) {
                this.disabledField();
                this.isInitial = false;
                this.showOTPBox = true;
                this.resendOTPTimerFn();
                this.setInputOTPValidation(true);
                this.service.showToast("An OTP has been sent to you (Valid upto 4 Minutes)..", 'Success')

                // Focus the OTP input box after enabling it
                // setTimeout(() => {
                //   const firstInput =
                //     this.OTP.nativeElement.querySelector(
                //       'input'
                //     );
                //   firstInput?.focus();
                // }, 0);

                setTimeout(() => {
                  if (this.OTP && this.OTP.nativeElement) {
                    const firstInput = this.OTP.nativeElement.querySelector('input');
                    firstInput?.focus();
                  }
                }, 0);

              } else {
                // this.service.showToast('OTP validated successfully');
                this.service.showToast("Password changed successfully", 'Success');
                this.dialogRef.close();

                this.passwordForm?.reset();
                this.router.navigate(['authentication'], {
                  replaceUrl: true,
                });
              }
            } else if (response.Header.Status === ADMIN_CONSTANT.ERROR_STATUS) {
              this.service.showToast(response.Error.ErrorMessage, 'Error!');

            }
          },
          (err) => 
          this.service.showToast(ADMIN_CONSTANT.SERVER_ERROR_MESSAGE, 'Error!')

        );
    } else {
      if (!this.passwordForm.valid) {
        this.passwordForm.markAllAsTouched();
        this.passwordForm.markAsDirty();
        this.service.showToast(ADMIN_CONSTANT.FORM_INVALID, 'Error!');

      } else if (!this.passwordForm.dirty) {
        this.service.showToast(ADMIN_CONSTANT.FORM_UNTOUCHED, 'Warning!');

      }
    }
  }
  

  get f() { return this.passwordForm.controls; }


  get DOB() {
    return this.passwordForm.get('DOB');
  }
  get Email() {
    return this.passwordForm.get('Email');
  }
  get AdminPassword() {
    return this.passwordForm.get('AdminPassword');
  }
  get ReAdminPassword() {
    return this.passwordForm.get('ReAdminPassword');
  }
  

  disabledField(): void {
    this.DOB?.disable();
    this.Email?.disable();
    this.AdminPassword?.disable();
    this.ReAdminPassword?.disable();
    this.passwordForm?.updateValueAndValidity();
  }



  private passwordMatchFn(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (
        control &&
        (!control.value.ReAdminPassword ||
          control.value.AdminPassword !== control.value.ReAdminPassword)
      ) {
        control.get('ReAdminPassword').setErrors({ unmatch: true });
        return { unmatch: true };
      }
      control.get('ReAdminPassword').setErrors(null);
      return null;
    };
  }


  getForgotPassResendOTP() {
    const PAYLOAD = this.passwordForm.getRawValue();
    PAYLOAD.DOB = !!PAYLOAD.DOB
      ? moment(PAYLOAD.DOB).format(GLOBAL_CONSTANTS.DOB_FORMAT)
      : null;
    this.service
      .onGlobalResetPassworResendOTP(PAYLOAD)
      .pipe(takeUntil(this.destroy))
      .subscribe(
        (response: any) => {
          // console.log("Response BasicInfo details fetch", response);
          if (response && response.Header.Status === ADMIN_CONSTANT.SUCCESS_STATUS) {
            this.resendOTPTimerFn();
            this.service.showToast("An OTP has been sent to you (Valid upto 4 Minutes)..", 'Success')
          } else {
            this.service.showToast(response.Error.ErrorMessage, 'Error!');
          }
        },
        (err: any) =>
          this.service.showToast(ADMIN_CONSTANT.SERVER_ERROR_MESSAGE, 'Error!')
      );
  }

  setInputOTPValidation(set: boolean): void {
    if (set) {
      this.InputOTP?.setValidators([
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(6),
        Validators.pattern('^\\d{6}$'),
      ]);
    } else {
      this.InputOTP?.clearValidators();
    }
    this.InputOTP?.updateValueAndValidity();
  }

  resendOTPTimerFn(): void {
    this.resendOTP = false;
    this.resendOTPTimer = GLOBAL_CONSTANTS.RESEND_OTP_TIMER;
    timer(GLOBAL_CONSTANTS.TIMER_DURATION_ULTRA_HIGH)
      .pipe(takeWhile(() => !this.resendOTP))
      .subscribe(() => (this.resendOTP = true));
    interval(1000)
      .pipe(takeWhile(() => !this.resendOTP, true))
      .subscribe(() => {
        this.resendOTPTimer = this.resendOTP
          ? GLOBAL_CONSTANTS.RESEND_OTP_TIMER
          : this.resendOTPTimer > 0
            ? --this.resendOTPTimer
            : 0;
      });
  }

  onOtpChange(value: string) {
    // value.length == 6 ? this.InputOTP?.setValue(value) : null;
    this.InputOTP?.setValue(value);
    this.InputOTP?.updateValueAndValidity();
  }


  displayFieldCss(form: FormGroup, field: string) {
    return {
      'is-invalid':
        form.get(field)!.invalid &&
        (form.get(field)!.dirty || form.get(field)!.touched),
      'is-valid':
        form.get(field)!.valid &&
        (form.get(field)!.dirty || form.get(field)!.touched),
    };
  }

}
